import axios from 'axios'
export default {
	get:function(module,parm){
		return new Promise((resolve,reject) => {
			axios({
				url:localStorage.ServerUrl+'/'+module,
				method: "GET",
				data:parm
			}).then((res) => {
				resolve(res.data);
			}).catch( (err) =>{
				reject(err);
			});
		});
	},
	post:function(module,parm){
		return new Promise((resolve,reject) => {
			axios({
				url:localStorage.ServerUrl+'/'+module,
				method: "POST",
				data:parm
			}).then((res) => {
				resolve(res.data);
			}).catch( (err) =>{
				reject(err);
			});
		});
	}
}


// WEBPACK FOOTER //
// ./src/utils/http/index.js